import React, { memo } from 'react';
import { FloatingLabel, Form } from 'react-bootstrap';
import { toast } from 'react-toastify';

const BasicForm = ({ onNextBtnClick, handleInput, input, modalTextHandler }) => {
  return (
    <>
      {/* <div className="col-12 shareLoginV2FormRow dt_steps dt_ProfileManagement">
        <div className="dt_step_panel">
          <h2 className="text-black fw-medium fs-16 mb-5">
            Channel Name &amp; Description
            <span className="mx-auto d-block rounded bg-primary dt_stepTextBtmBorder mt-3"></span>
          </h2>

          <div className="dt_step_form mx-auto mw-100">
            <form>
              <FloatingLabel
                className="floatingFrmRow"
                controlId="floatingInput"
                label="Channel Name*"
              >
                <Form.Control
                  className="fs-4"
                  type="text"
                  placeholder="Enter Channel Name*"
                  value={input?.channel_name}
                  name={'channel_name'}
                  onChange={handleInput}
                />
              </FloatingLabel>
              <FloatingLabel
                className="floatingFrmRow mt-4"
                controlId="floatingTextarea2"
                label="Channel Description*"
              >
                <Form.Control
                  className="fs-4"
                  as="textarea"
                  placeholder="Enter Channel Description *"
                  rows={3}
                  name="about"
                  value={input?.about}
                  onChange={handleInput}
                />
              </FloatingLabel>
              <FloatingLabel
                className="floatingFrmRow"
                controlId="floatingInput"
                label="Consult link (If any)"
              >
                <Form.Control
                  className="fs-4"
                  type="text"
                  placeholder="Enter Consult link"
                  value={input?.consult_link}
                  name={'consult_link'}
                  onChange={handleInput}
                />
              </FloatingLabel>

              <div className="d-flex dt_step_Submit mt-4">
                <button
                  type="button"
                  className={`cmnBtn rounded-3 text-white flex-1 d-flex align-items-center justify-content-center fs-4 bg-secondary fw-medium ${
                    !input?.channel_name || !input?.about ? 'disabled' : ''
                  }`}
                  disabled={!input?.channel_name || !input?.about}
                  onClick={() => {
                    onNextBtnClick(2);
                  }}
                >
                  Next
                </button>
              </div>
            </form>
          </div>
        </div>
      </div> */}
      <div className="col-12 shareLoginV2FormRow dt_steps dt_ProfileManagement p-0 position-relative">
        <div className="dt_step_panel">
          <h2 className="text-black fw-medium fs-16 mb-5 text-center">
            Your personal channel details
            <span className="mx-auto d-block rounded bg-primary dt_stepTextBtmBorder mt-3"></span>
          </h2>

          <div className="dt_step_form mx-auto w-100 mw-100">
            <form>
              <FloatingLabel controlId="floatingInput" label="Name Your channel*">
                <Form.Control
                  className="fs-4"
                  type="text"
                  placeholder="Enter Channel Name*"
                  value={input?.channel_name}
                  name={'channel_name'}
                  onChange={handleInput}
                />
                <span className="mb-2 mt-3 fs-6 descriptionAnimation">
                  Channel name your personal profile page on DocTube where patients will be able to
                  see a selection of all your videos. E.g. your name! Check out a sample HERE.
                </span>
              </FloatingLabel>

              <FloatingLabel
                className="mt-4"
                controlId="floatingTextarea2"
                label="Describe the channel*"
              >
                <Form.Control
                  className="fs-4"
                  as="textarea"
                  placeholder="Enter Channel Description *"
                  rows={3}
                  name="about"
                  value={input?.about}
                  onChange={handleInput}
                />
                <span className="mb-2 mt-3 fs-6 descriptionAnimation">
                  Write a few lines about yourself and the kind of videos that you want to post. See
                  a sample text HERE.
                </span>
              </FloatingLabel>
              <FloatingLabel
                className="mt-4"
                controlId="floatingInput"
                label="Link to your online appintment system"
              >
                <Form.Control
                  className="fs-4"
                  type="text"
                  placeholder="Enter your online appointment link"
                  value={input?.consult_link}
                  name={'consult_link'}
                  onChange={handleInput}
                />
                <span className="mb-2 mt-3 fs-6 descriptionAnimation">
                  Patients might wish to reach out to you for consultations! Please add the link to
                  your appointment system here!
                </span>
              </FloatingLabel>

              <div className="d-flex dt_step_Submit mt-4 p-0">
                <button
                  className="dt_backBtn rounded-3 d-flex align-items-center justify-content-center fs-4 btn btn-light fw-medium me-2 p-4"
                  type="button"
                  onClick={() => modalTextHandler('modal')}
                >
                  Skip
                </button>
                <button
                  type="button"
                  className={`dt_nextBtn rounded-3 flex-1 d-flex align-items-center justify-content-center fs-4 btn btn-secondary fw-medium ms-2 p-4 ${
                    !input?.channel_name || !input?.about ? 'disabled' : ''
                  }`}
                  disabled={!input?.channel_name || !input?.about}
                  onClick={() => {
                    onNextBtnClick(2);
                  }}
                >
                  Next
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};
export default memo(BasicForm);